import React, { useEffect, useRef } from "react";
import "../styles/Products.css";
import {
  MdSecurity,
  MdGavel,
  MdBalance,
  MdAssignment,
  MdPersonSearch,
  MdNotificationImportant,
  MdFactCheck,
  MdCampaign,
  MdLock,
  MdDescription,
  MdTrackChanges,
  MdGroup,
  MdSearch,
  MdManageAccounts,
  MdSchool,
  MdVerifiedUser,
  MdCorporateFare,
} from "react-icons/md";

const Products: React.FC = () => {
  const sectionRefs = useRef<HTMLDivElement[]>([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.08 }
    );

    sectionRefs.current.forEach((ref) => {
      if (ref) observer.observe(ref);
    });

    const refs = sectionRefs.current;
    return () => {
      refs.forEach((ref) => {
        if (ref) observer.unobserve(ref);
      });
    };
  }, []);

  const addToRefs = (el: HTMLDivElement | null) => {
    if (el && !sectionRefs.current.includes(el)) {
      sectionRefs.current.push(el);
    }
  };

  return (
    <div className="products-container">
      <div className="products-header animate-section" ref={addToRefs}>
        <div className="header-icon"><MdSecurity /></div>
        <h1 className="main-title">Suç Gelirlerinin Önlenmesi Politikası</h1>
        <div className="subtitle">Suç Gelirlerinin Aklanmasının ve Terörün Finansmanının Önlenmesi</div>
      </div>

      <div className="company-info animate-section" ref={addToRefs}>
        <div className="company-name">ATS DÖVİZ ALTIN TİCARETİ YETKİLİ MÜESSESE ANONİM ŞİRKETİ</div>
        <p className="company-description">
          Suç gelirlerinin aklanması, terörizmin finansmanı ve bağlantılı diğer suçlar ile olan mücadelede 
          ulusal ve uluslararası standartlara uygun olarak faaliyet göstermektedir.
        </p>
      </div>

      <div className="legal-framework animate-section" ref={addToRefs}>
        <h2 className="section-title"><MdGavel className="section-icon" /> Yasal Çerçeve</h2>
        <div className="laws-grid">
          <div className="law-card animate-card">
            <div className="law-number">5549</div>
            <div className="law-title">Suç Gelirlerinin Aklanmasının Önlenmesi Hakkında Kanun</div>
          </div>
          <div className="law-card animate-card">
            <div className="law-number">6415</div>
            <div className="law-title">Terörizmin Finansmanının Önlenmesi Hakkında Kanun</div>
          </div>
          <div className="law-card animate-card">
            <div className="law-number">7262</div>
            <div className="law-title">Kitle İmha Silahlarının Yayılmasının Finansmanının Önlenmesine İlişkin Kanun</div>
          </div>
        </div>
        <p className="legal-note">
          Bu kanunlara dayanılarak çıkarılmış Yönetmelikler ve Tebliğler ile MASAK Rehberleri, 
          Birleşmiş Milletler, FATF, Avrupa Parlamentosu ve Avrupa Birliği Konseyi gibi kuruluşlar 
          ve sair uluslararası otoritelerce getirilen tavsiye, ilke, standart ve rehberlere uygun olarak yürütülmektedir.
        </p>
      </div>

      <div className="obligations animate-section" ref={addToRefs}>
        <h2 className="section-title"><MdBalance className="section-icon" /> Yükümlülüklerimiz</h2>
        <p className="obligation-intro">
          İlgili yasal düzenlemeler mevzuatı kapsamında "Yükümlü" grubunda yer alan Şirketimiz, 
          söz konusu kanun kapsamında aşağıdaki yükümlülüklere tabidir:
        </p>
        <div className="obligations-list">
          <div className="obligation-item animate-card">
            <div className="obligation-icon"><MdPersonSearch /></div>
            <div className="obligation-text">Müşterinin tanınması</div>
          </div>
          <div className="obligation-item animate-card">
            <div className="obligation-icon"><MdNotificationImportant /></div>
            <div className="obligation-text">Şüpheli işlem bildirimi</div>
          </div>
          <div className="obligation-item animate-card">
            <div className="obligation-icon"><MdFactCheck /></div>
            <div className="obligation-text">Uyum programı oluşturulması</div>
          </div>
          <div className="obligation-item animate-card">
            <div className="obligation-icon"><MdCampaign /></div>
            <div className="obligation-text">Devamlı bilgi verme</div>
          </div>
          <div className="obligation-item animate-card">
            <div className="obligation-icon"><MdLock /></div>
            <div className="obligation-text">Muhafaza ve ibraz</div>
          </div>
          <div className="obligation-item animate-card">
            <div className="obligation-icon"><MdDescription /></div>
            <div className="obligation-text">Bilgi ve belge verme</div>
          </div>
        </div>
      </div>

      <div className="compliance-program animate-section" ref={addToRefs}>
        <h2 className="section-title"><MdTrackChanges className="section-icon" /> Uyum Programı</h2>
        <p className="program-description">
          ATS DÖVİZ ALTIN TİCARETİ YETKİLİ MÜESSESE ANONİM ŞİRKETİ, suç gelirlerinin aklanması 
          ve terörün finansmanının önlenmesine ilişkin Kanunlar ile bu kanunlara dayanılarak çıkarılan 
          alt düzenlemeler kapsamındaki yükümlülüklere gerekli uyumun sağlanması amacıyla risk temelli 
          bir yaklaşımla aşağıdaki tedbirleri içeren bir uyum programı oluşturmuştur.
        </p>
        
        <div className="program-structure">
          <div className="structure-item animate-card">
            <div className="structure-icon"><MdGroup /></div>
            <div className="structure-content">
              <h3>Görevli Atamaları</h3>
              <p>"Uyum Görevlisi" ile "Uyum Görevlisi Yardımcısı" atanmış, kurum politikası ve 
              prosedürleri oluşturularak Yönetim Kurulumuzca onaylanmıştır.</p>
            </div>
          </div>
        </div>

        <div className="policy-areas">
          <h3 className="policy-title">Kurum Politikası Kapsamı</h3>
          <div className="policy-grid">
            <div className="policy-card animate-card">
              <div className="policy-icon"><MdPersonSearch /></div>
              <div className="policy-text">Müşteri kabul politikasına, müşterinin tanınmasına, izlenmesine ve bu amaçla kimlik tespitine yönelik temel prensip ve kuralları</div>
            </div>
            <div className="policy-card animate-card">
              <div className="policy-icon"><MdBalance /></div>
              <div className="policy-text">Risk yönetimi faaliyetlerinin yürütülmesine ilişkin esasları</div>
            </div>
            <div className="policy-card animate-card">
              <div className="policy-icon"><MdSearch /></div>
              <div className="policy-text">İzleme ve kontrol faaliyetlerinin yürütülmesine ilişkin esasları</div>
            </div>
            <div className="policy-card animate-card">
              <div className="policy-icon"><MdManageAccounts /></div>
              <div className="policy-text">Uyum görevlisi ve uyum görevlisi yardımcısı atanmasına ilişkin esaslar ile atanan uyum görevlisinin yetki ve sorumlulukları</div>
            </div>
            <div className="policy-card animate-card">
              <div className="policy-icon"><MdSchool /></div>
              <div className="policy-text">Eğitim faaliyetlerinin yürütülmesine ilişkin esasları</div>
            </div>
            <div className="policy-card animate-card">
              <div className="policy-icon"><MdVerifiedUser /></div>
              <div className="policy-text">İç denetim faaliyetlerinin yürütülmesine ilişkin esasları</div>
            </div>
          </div>
        </div>
      </div>

      <div className="responsibility animate-section" ref={addToRefs}>
        <h2 className="section-title"><MdAssignment className="section-icon" /> Sorumluluk</h2>
        <div className="responsibility-content animate-card">
          <div className="responsibility-icon"><MdCorporateFare /></div>
          <p className="responsibility-text">
            Uyum programının yeterli, etkin ve uygun bir şekilde yürütülmesi nihai olarak 
            <strong>Yönetim Kurulu</strong> sorumluluğunda olmakla birlikte bütün çalışanlarımız da 
            bu programın gerekliliklerine uymak ile yükümlüdürler.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Products;
